(function () {
  const HOVER_CLASS = 'nav-hover-enabled';
  const CLOSE_DELAY_MS = 150;
  const hoverMql = window.matchMedia('(hover: hover) and (pointer: fine)');
  const handlerState = new WeakMap();

  function isHoverModeActive() {
    return document.documentElement.classList.contains(HOVER_CLASS) && hoverMql.matches;
  }

  function openMenu(headerMenu) {
    const details = headerMenu.querySelector('details');
    if (!details || details.hasAttribute('open')) return;
    details.setAttribute('open', '');
    headerMenu.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    details.dispatchEvent(new Event('toggle'));
  }

  function closeMenu(headerMenu) {
    const details = headerMenu.querySelector('details');
    if (!details || !details.hasAttribute('open')) return;
    details.removeAttribute('open');
    headerMenu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    details.dispatchEvent(new Event('toggle'));
  }

  function attach(headerMenu) {
    if (handlerState.has(headerMenu)) return;
    const summary = headerMenu.querySelector('summary');
    if (!summary) return;

    const h = {
      closeTimer: null,
      onMouseEnter() {
        clearTimeout(h.closeTimer);
        document.querySelectorAll('header-menu details[open]').forEach((d) => {
          const otherMenu = d.closest('header-menu');
          if (otherMenu && otherMenu !== headerMenu) closeMenu(otherMenu);
        });
        openMenu(headerMenu);
      },
      onMouseLeave() {
        clearTimeout(h.closeTimer);
        h.closeTimer = setTimeout(() => closeMenu(headerMenu), CLOSE_DELAY_MS);
      },
      onClick(e) {
        if (e.pointerType !== 'mouse' || e.detail === 0) return;
        const href = summary.getAttribute('data-href');
        if (!href || href === '#') return;
        e.preventDefault();
        e.stopPropagation();
        window.location.href = href;
      },
    };

    headerMenu.addEventListener('mouseenter', h.onMouseEnter);
    headerMenu.addEventListener('mouseleave', h.onMouseLeave);
    summary.addEventListener('click', h.onClick);
    handlerState.set(headerMenu, h);
  }

  function detach(headerMenu) {
    const h = handlerState.get(headerMenu);
    if (!h) return;
    clearTimeout(h.closeTimer);
    headerMenu.removeEventListener('mouseenter', h.onMouseEnter);
    headerMenu.removeEventListener('mouseleave', h.onMouseLeave);
    headerMenu.querySelector('summary')?.removeEventListener('click', h.onClick);
    handlerState.delete(headerMenu);
  }

  function syncAll() {
    const menus = document.querySelectorAll('header-menu');
    if (isHoverModeActive()) {
      menus.forEach(attach);
    } else {
      menus.forEach((m) => {
        detach(m);
        closeMenu(m);
      });
    }
  }

  syncAll();

  new MutationObserver(syncAll).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });

  hoverMql.addEventListener('change', syncAll);
})();
